import React from "react";
import { message, Form, Checkbox } from "antd";
import styled from "styled-components";
import { PercentageOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Upload from "components/buttons/Upload";
import Input, { TextArea } from "components/inputs/Input";
import NumberInput from "components/inputs/NumberInput";
import Select from "components/inputs/Select";
import Fetch from "components/Fetch";
import { StyledModal } from "components/App/styled";
export default function App({ visible, setVisible, data, reload, oldData }) {
  const [form] = Form.useForm();

  const [loading, setLoading] = React.useState(false);

  const showModal = () => {
    setVisible(true);
  };
  // console.log("+++++++++++++++++", images);
  React.useEffect(() => {}, [visible, oldData]);

  const onSubmit = (data) => {
    const submitData = {
      ...data,
      data: JSON.stringify([]),
    };
    setLoading(true);
    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/coupon", submitData, (res) => {
        console.log("new coupon response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res.code) {
            message.error(res.code[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/coupon/${oldData.id}`, submitData, (res) => {
        console.log("new coupon response/ UPDATE", res);
        if (res?.ok) {
          message.success("با موفقیت آپدیت شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res?.code) {
            message.error(res.code[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setLoading(false);
  };
  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const cleanForm = () => {
    form.setFieldsValue({
      title: null,
      stock: null,
      price: null,
      description: null,
    });
  };

  if (oldData) {
    form.setFieldsValue(oldData);
  }

  return (
    <>
      <StyledModal
        title={oldData ? "به روز رسانی" : " اضافه کردن کد تخفیف"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
            style={{ width: "100%" }}
            color={colors.blue}
          >
            ثبت
          </Button>,
        ]}
        width={640}
      >
        <Form
          form={form}
          layout="vertical"
          style={{ direction: "rtl" }}
          //   requiredMark={requiredMark}
          onFinish={onSubmit}
        >
          <ColContainer>
            <Col>
              <Label>عنوان کد تخفیف :</Label>
              <Form.Item
                name="title"
                rules={[
                  { required: true, message: "لطفا عنوان را وارد کنید!" },
                ]}
              >
                <Input size="large" placeholder="" />
              </Form.Item>
              <Label>کد تخفیف :</Label>
              <Form.Item name="code">
                <Input size="large" placeholder="" />
              </Form.Item>

              <Label>تعداد دفعات قابل استفاده :</Label>
              <Form.Item
                name="count"
                rules={[
                  {
                    required: true,
                    message: "لطفا تعداد دفعات قابل استفاده را وارد کنید!",
                  },
                ]}
              >
                <NumberInput style={{ width: "100%" }} />
              </Form.Item>
              <Label>درصد تخفیف :</Label>
              <Form.Item
                name="off_percent"
                rules={[
                  {
                    required: true,
                    message: "لطفا قیمت را وارد کنید!",
                  },
                ]}
              >
                <NumberInput
                  style={{ width: "100%" }}
                  min={1}
                  max={99}
                  prefix={<PercentageOutlined />}
                />
              </Form.Item>
              <Label>حداکثر مبلغ تخفیف :</Label>
              <Form.Item
                name="max"
                rules={[
                  {
                    required: true,
                    message: "لطفا حداکثر مبلغ را وارد کنید!",
                  },
                ]}
              >
                <NumberInput
                  style={{ width: "100%" }}
                  prefix={<span>تومان</span>}
                />
              </Form.Item>

              <Form.Item
                name="active"
                valuePropName="checked"
                getValueFromEvent={(e) => (e.target.checked ? 1 : 0)}
              >
                <Checkbox>فعال کردن تخفیف</Checkbox>
              </Form.Item>

              {/* <Label>توضیحات :</Label>

              <Form.Item name="description">
                <TextArea rows={5} />
              </Form.Item> */}
            </Col>
          </ColContainer>
        </Form>
      </StyledModal>
    </>
  );
}
const ColContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
